<template>
    <div class="main_wrap">
        <div class="blockBox blockBox_form top_border_blue bc_white shadow mt_20">
            <!-- 表单部分 -->
            <el-form
                class="formBox"
                label-position="right"
                label-width="1.1rem"
                label-suffix="："
                :model="form"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="开盘时间">
                            <TimeSelect
                                :timeList="timeList"
                                :activeTimeProp="form.iTimeType"
                                @selectTime="selectTime"
                            ></TimeSelect>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="销售状态">
                            <MultipleSelect
                                value-type="label"
                                paramKey="aSaleState"
                                :selection="staticEnum.saleStatus"
                                @selectOption="selectOption"
                            ></MultipleSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属城市">
                                    <!-- <CitySearch :city="form.sCity" @chooseCity="chooseCity"></CitySearch> -->
                                    <MultipleSelectDiy
                                        :options="cityData"
                                        :defaultVal="defaultCity"
                                        placeholderWrap="不限"
                                        :placeholderData="['搜索省份','搜索城市']"
                                        :hasCheckAll="true"
                                        @valueChange="valChange"
                                        @clearAll="clearAll"
                                        @delFirstItem="delFirst"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="房企">
                                    <!-- <CompanySearch :company="form.sCompanyType" @searchCompany="searchCompany"></CompanySearch> -->
                                    <CompanySearchNew
                                        :companyList="companyList"
                                        :companyData="companyDefaultObj"
                                        @submitCheck="checkCompany"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-row>
                            <el-form-item label="物业类型">
                                <MultipleSelect
                                    value-type="label"
                                    paramKey="aHouseTypeArr"
                                    :selection="staticEnum.propertyType"
                                    @selectOption="selectOption"
                                ></MultipleSelect>
                            </el-form-item>
                        </el-row>
                    </el-col>
                </el-row>
            </el-form>

            <!-- 表单展示（charts） -->
            <div class="formShow_chart">
                <div class="showDetail">
                    <ul class="innerBox">
                        <li
                            class="item"
                            v-for="(item,index) in chartListData.aSumAndCount"
                            :key="index"
                        >
                            <p class="value">{{item.value}}</p>
                            <p class="label">{{item.label}}</p>
                        </li>
                    </ul>
                </div>
                <div class="showChart flex_justify_around">
                    <div class="w_40 h_100">
                        <Echarts :options="getOptions('pie',pieChartsData)"></Echarts>
                    </div>
                    <div class="w_45 h_100">
                        <Echarts :options="getOptions('base',lineBarChartsData)"></Echarts>
                    </div>
                </div>
            </div>
        </div>
        <div class="formShow_table">
            <div class="blockHead flex_justify_between mt_20">
                <p class="blockTitle">
                    <span class="name">全装修项目最新开盘</span>
                    <span class="split">|</span>
                    <span class="value">共{{total}}条数据</span>
                </p>
                <div class="searchBox flex_align">
                    <Search placeholder="请输入项目名称、城市、开发商、开发商简称关键字搜索" @handleIconClick="search"></Search>
                    <BaseExport module="market" @exportData="exportData" />
                </div>
            </div>
            <div class="blockBox bc_white shadow">
                <TableList :tableObj="tableObj" :type="2" :module="3"></TableList>
            </div>
            <!-- 分页器 -->
            <Pagination
                :total="total"
                :current="currentPage"
                :pageSize="pageSize"
                @pageChange="pageChange"
            ></Pagination>
        </div>
    </div>
</template>
<script>
import staticEnum from '@/utils/staticEnum'
import Echarts from '@/components/Echarts'
import getCharts from '@/utils/getCharts.js'
import chartSet from '@/config/chartSet'
import ajaxService from '@/server/api.js'
import listCommonMixin from '@/mixins/listCommon.js'
export default {
    mixins: [listCommonMixin],
    data() {
        return {
            staticEnum,
            timeList: staticEnum.timeList.slice(1, 5),
            form: {
                //用于图表传参
                iTimeType: '', //时间类型
                sStartTime: '', //自定义开始时间
                sEndTime: '', //自定义结束时间
                sCity: '', //城市
                sCompanyType: '', //公司
                aSaleState: [], //销售状态
                aHouseTypeArr: [] //物业类型
            },
            sKeyword: '', //搜索关键字
            currentPage: 1, //当前页数
            total: 0, //表格列表总条数
            pageSize: 0, //表格列表单页条数
            chartListData: {}, //图表部分数据
            tableObj: {
                //表格数据
                tableHead: [
                    {
                        prop: 'Caption',
                        label: '项目名称',
                        align: 'left',
                        width: 150
                    },
                    {
                        prop: 'CityCaption',
                        label: '城市',
                        align: 'center'
                        // width:60
                    },
                    {
                        prop: 'TotalBuildArea',
                        label: '总建面积(㎡)',
                        align: 'center'
                        // width:100
                    },
                    {
                        prop: 'HomeType',
                        label: '项目属性',
                        align: 'center'
                        // width:80
                    },
                    {
                        prop: 'Fitment',
                        label: '装修情况',
                        align: 'center'
                        // width:100
                    },
                    {
                        prop: 'Developer',
                        label: '开发商',
                        align: 'center',
                        width: 180
                    },
                    {
                        prop: 'OpenTime',
                        label: '最早开盘日期',
                        align: 'center',
                        width: 120
                    },
                    {
                        prop: 'NewOpenTime',
                        label: '最新开盘时间',
                        align: 'center',
                        width: 120
                    }
                ],
                tableData: []
            }
        }
    },
    components: {
        Echarts
    },
    watch: {
        form: {
            handler(newVal, oldVal) {
                this.currentPage = 1
                this.initData()
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        tableParam() {
            //表格列表的参数
            let temp = {
                sKeyword: this.sKeyword,
                page: this.currentPage
            }
            return { ...this.form, ...temp }
        },
        pieChartsData() {
            let obj = {
                title: '物业类型\n占比',
                data: this.chartListData.aHomeType
            }
            return chartSet.listPieCharts(obj)
        },
        lineBarChartsData() {
            let obj = {
                title: '全装修面积、全装修项目趋势',
                xAxisData: [],
                series: [
                    {
                        type: 'bar',
                        name: '全装修面积',
                        data: [],
                        unit: '万㎡'
                    },
                    {
                        type: 'line',
                        name: '全装修项目数',
                        data: [],
                        unit: '个'
                    }
                ]
            }
            if (this.chartListData.aProjectTrend && this.chartListData.aProjectTrend.length) {
                this.chartListData.aProjectTrend.forEach((item) => {
                    obj.xAxisData.push(item.sCateDesc)
                    obj.series[0].data.push(item.TotalBuildArea)
                    obj.series[1].data.push(item.iCnt)
                })
            }
            return chartSet.listLineBarCharts(obj)
        }
    },
    created() {
        // this.initRouter()
        // this.initData()
        document.title = '全装修市场监控系统 - 优采大数据'
    },
    methods: {
        initRouter() {
            // console.log(this.$route.query)
            if (this.$route.query.activeTime) {
                this.form.iTimeType = this.$route.query.activeTime
            } else {
                this.form.iTimeType = this.staticEnum.timeList.slice(1, 5)[0].value
            }
            if (this.$route.query.type && this.$route.query.name) {
                switch (this.$route.query.type) {
                    case 'company':
                        this.form.sCompanyType = this.$route.query.name
                        this.setCompanyByDefaultVal(this.$route.query.name)
                        break
                    case 'city':
                        this.form.sCity = this.$route.query.name
                        this.setCityByDefaultCity(this.$route.query.name)
                        break
                }
            }
        },
        // 初始化数据
        initData() {
            this.getChartData(this.form) //图表数据
            this.getListData(this.tableParam) //表格数据
        },
        // 选择时间
        selectTime(val) {
            console.log('选择时间', val)
            this.form.iTimeType = val.activeTime
            if (this.form.iTimeType == 4) {
                this.form.sStartTime = val.diyTime[0]
                this.form.sEndTime = val.diyTime[1]
            }
        },
        // 搜索
        search(key) {
            console.log('搜索', key)
            this.sKeyword = key
            this.getListData(this.tableParam)
        },
        // 城市选择
        chooseCity(city) {
            console.log('城市选择', city)
            this.form.sCity = city
        },
        // 房企选择
        searchCompany(val) {
            console.log('房企选择', val)
            this.form.sCompanyType = val
        },
        // 多选
        selectOption(obj) {
            console.log('选择了', obj)
            this.form[obj.key] = obj.data
        },
        // page页数改变
        pageChange(page) {
            console.log('page页数改变', page)
            this.currentPage = page

            this.getListData(this.tableParam)
        },

        // 获取图表栏数据
        getChartData(param) {
            ajaxService.getProjectDataByInput(param).then((res) => {
                console.log('图表栏数据', res)
                if (!res.ErrorCode) {
                    this.chartListData = res.Data
                }
            })
        },
        // 获取表格列表
        getListData(param) {
            ajaxService
                .getNewDecorateList(param)
                .then((res) => {
                    console.log('表格列表', res)
                    if (param.iExport) {
                        this.exportSet(res, '全装修项目最新开盘')
                    } else {
                        if (!res.ErrorCode) {
                            this.tableObj.tableData = res.Data.aList
                            this.total = Number(res.Data.iTotal)
                            this.pageSize = res.Data.iPageSize
                        }
                    }
                })
                .catch((err) => {
                    console.log('error', err)
                })
        },
        // Echarts
        getOptions(echartType, obj) {
            switch (echartType) {
                case 'pie':
                    let pieoption = getCharts.getPieEchart(obj)
                    return pieoption
                    break
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj)
                    return baseoption
                    break
                default:
                    break
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
